import { createContext, ReactNode, useEffect, useState } from "react";

type TableMonitor = {
  selectedOrder: string;
  setSelectedOrder: (orderBy: string) => void;
  sortAsc: boolean;
  setSortAsc: (asc: boolean) => void;
};

type TableMonitorProps = {
  children: ReactNode;
};

const TableMonitorContext = createContext({} as TableMonitor);

function TableMonitorProvider({ children }: TableMonitorProps) {
  const [selectedOrder, setSelectedOrder] = useState<string>("createdAt");
  const [sortAsc, setSortAsc] = useState<boolean>(false);

  return (
    <TableMonitorContext.Provider
      value={{
        selectedOrder, setSelectedOrder,
        sortAsc, setSortAsc
      } as TableMonitor}
    >
      {children}
    </TableMonitorContext.Provider>
  );
}

export { TableMonitorContext, TableMonitorProvider };
